const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
const ISO_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?(Z|[+-]\d{2}:\d{2})$/;

// A date-only value is a calendar day, so it is read as local midnight to keep the same day.
export function formatChangeDate(value) {
  if (typeof value !== 'string') return null;
  const isDateOnly = ISO_DATE.test(value);
  if (!isDateOnly && !ISO_DATE_TIME.test(value)) return null;

  const date = new Date(isDateOnly ? `${value}T00:00:00` : value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString(
    undefined,
    isDateOnly ? { dateStyle: 'medium' } : { dateStyle: 'medium', timeStyle: 'short' },
  );
}
